import { WalletService } from "@/generated/services/WalletService";
import { useQuery } from "@tanstack/react-query";

export function useFetchWallet(memberId: number) {
  return useQuery({
    queryKey: ["wallet", memberId],
    enabled: !!memberId, // only run when memberId is valid
    queryFn: async () => {
      const response = await WalletService.getMembersWallet(
        memberId,
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
        undefined,
        undefined,
        30,
      );
      return response;
    },
    refetchOnMount: "always", // Refetch whenever the component mounts
    refetchOnWindowFocus: true,
    refetchOnReconnect: false,
  });
}
